import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { CollectionPurposeDataProvider } from "../../data-provider/collection-purpose.dp";

let CollectionPurposeViewDialogComponent = {
    selector: "vcCollectionPurposeViewDialog",
    templateUrl:
        "/angular/components/collection-purpose/collection-purpose-dialog.component.html",
    bindings: {
        point: "=?",
    },
    controller: class CollectionPurposeViewDialogController {
        // * bindings for typescript compiler *
        public point?: any;
        // ************************************

        private $scope: any;
        private dialog: DialogUtils;
        private dataProvider: CollectionPurposeDataProvider;
        public collection: any[];

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            CollectionPurposeDataProvider: CollectionPurposeDataProvider
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.dataProvider = CollectionPurposeDataProvider;
        }

        $onInit() {
            this.point = _.cloneDeep(this.point);
            this.dataProvider.all().then((purposes: any) => {
                this.collection = purposes;
            });
        }

        cancel(): void {
            this.dialog.cancel();
        }

        changePurpose(data: any): void {
            if (data) {
                this.point.purpose = data.purpose;
                this.point.cpid = data.cpid;
            }
        }

        saveCollectionPurpose(datapoint: any): void {
            if (datapoint.dpcpid != null) {
                this.dataProvider.update(datapoint).then((point: any) => {
                    point.purpose = datapoint.purpose;
                    this.dialog.hide(point);
                });
            } else {
                this.dataProvider.create(datapoint).then((point: any) => {
                    point.purpose = datapoint.purpose;
                    this.dialog.hide(point);
                });
            }
        }

        createCollectionPurposeModal($event: any): void {
            this.dialog
                .show({
                    component: "vc-legal-reason-create",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {},
                })
                .then((purpose: object) => {
                    if (angular.isDefined(purpose)) {
                        this.collection.push(purpose);
                        this.changePurpose(purpose);
                    }
                });
        }
    },
};

angular
    .module("collectionpurpose", [])
    .component(
        CollectionPurposeViewDialogComponent.selector,
        CollectionPurposeViewDialogComponent
    );
